/* tslint:disable */
/* eslint-disable */
/**
 * IbanOplata.Web
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: v1
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


import type { Configuration } from '../configuration';
import type { AxiosPromise, AxiosInstance, RawAxiosRequestConfig } from 'axios';
import globalAxios from 'axios';
// Some imports not used depending on template conditions
// @ts-ignore
import { DUMMY_BASE_URL, assertParamExists, setApiKeyToObject, setBasicAuthToObject, setBearerAuthToObject, setOAuthToObject, setSearchParams, serializeDataIfNeeded, toPathString, createRequestFunction } from '../common';
// @ts-ignore
import { BASE_PATH, COLLECTION_FORMATS, type RequestArgs, BaseAPI, RequiredError, operationServerMap } from '../base';
// @ts-ignore
import type { BankTokenAddMonobankResponseDto } from '../models';
// @ts-ignore
import type { BankTokenAddPrivatBankCommand } from '../models';
// @ts-ignore
import type { BankTokenCompleteMonobankCommand } from '../models';
// @ts-ignore
import type { BankTokenResponseDto } from '../models';
// @ts-ignore
import type { BankTokenUpdateCommand } from '../models';
// @ts-ignore
import type { MonobankCheckRequestStatusDto } from '../models';
/**
 * BankTokenApi - axios parameter creator
 * @export
 */
export const BankTokenApiAxiosParamCreator = function (configuration?: Configuration) {
    return {
        /**
         * 
         * @param {string} bankTokenUid 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiBankTokenBankTokenUidDelete: async (bankTokenUid: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'bankTokenUid' is not null or undefined
            assertParamExists('apiBankTokenBankTokenUidDelete', 'bankTokenUid', bankTokenUid)
            const localVarPath = `/api/bank-token/{bankTokenUid}`
                .replace(`{${"bankTokenUid"}}`, encodeURIComponent(String(bankTokenUid)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'DELETE', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication Bearer required
            await setApiKeyToObject(localVarHeaderParameter, "Authorization", configuration)


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {string} bankTokenUid 
         * @param {BankTokenUpdateCommand} [bankTokenUpdateCommand] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiBankTokenBankTokenUidPut: async (bankTokenUid: string, bankTokenUpdateCommand?: BankTokenUpdateCommand, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'bankTokenUid' is not null or undefined
            assertParamExists('apiBankTokenBankTokenUidPut', 'bankTokenUid', bankTokenUid)
            const localVarPath = `/api/bank-token/{bankTokenUid}`
                .replace(`{${"bankTokenUid"}}`, encodeURIComponent(String(bankTokenUid)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'PUT', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication Bearer required
            await setApiKeyToObject(localVarHeaderParameter, "Authorization", configuration)


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(bankTokenUpdateCommand, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiBankTokenGet: async (options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/api/bank-token`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication Bearer required
            await setApiKeyToObject(localVarHeaderParameter, "Authorization", configuration)


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {BankTokenCompleteMonobankCommand} [bankTokenCompleteMonobankCommand] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiBankTokenMonobankCompletePost: async (bankTokenCompleteMonobankCommand?: BankTokenCompleteMonobankCommand, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/api/bank-token/monobank/complete`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication Bearer required
            await setApiKeyToObject(localVarHeaderParameter, "Authorization", configuration)


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(bankTokenCompleteMonobankCommand, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {object} [body] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiBankTokenMonobankInitPost: async (body?: object, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/api/bank-token/monobank/init`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication Bearer required
            await setApiKeyToObject(localVarHeaderParameter, "Authorization", configuration)


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(body, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {string} bankTokenUid 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiBankTokenMonobankStatusBankTokenUidGet: async (bankTokenUid: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'bankTokenUid' is not null or undefined
            assertParamExists('apiBankTokenMonobankStatusBankTokenUidGet', 'bankTokenUid', bankTokenUid)
            const localVarPath = `/api/bank-token/monobank/status/{bankTokenUid}`
                .replace(`{${"bankTokenUid"}}`, encodeURIComponent(String(bankTokenUid)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication Bearer required
            await setApiKeyToObject(localVarHeaderParameter, "Authorization", configuration)


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {BankTokenAddPrivatBankCommand} [bankTokenAddPrivatBankCommand] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiBankTokenPrivatbankPost: async (bankTokenAddPrivatBankCommand?: BankTokenAddPrivatBankCommand, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/api/bank-token/privatbank`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication Bearer required
            await setApiKeyToObject(localVarHeaderParameter, "Authorization", configuration)


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(bankTokenAddPrivatBankCommand, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
    }
};

/**
 * BankTokenApi - functional programming interface
 * @export
 */
export const BankTokenApiFp = function(configuration?: Configuration) {
    const localVarAxiosParamCreator = BankTokenApiAxiosParamCreator(configuration)
    return {
        /**
         * 
         * @param {string} bankTokenUid 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async apiBankTokenBankTokenUidDelete(bankTokenUid: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<void>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.apiBankTokenBankTokenUidDelete(bankTokenUid, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['BankTokenApi.apiBankTokenBankTokenUidDelete']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @param {string} bankTokenUid 
         * @param {BankTokenUpdateCommand} [bankTokenUpdateCommand] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async apiBankTokenBankTokenUidPut(bankTokenUid: string, bankTokenUpdateCommand?: BankTokenUpdateCommand, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<void>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.apiBankTokenBankTokenUidPut(bankTokenUid, bankTokenUpdateCommand, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['BankTokenApi.apiBankTokenBankTokenUidPut']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async apiBankTokenGet(options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<Array<BankTokenResponseDto>>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.apiBankTokenGet(options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['BankTokenApi.apiBankTokenGet']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @param {BankTokenCompleteMonobankCommand} [bankTokenCompleteMonobankCommand] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async apiBankTokenMonobankCompletePost(bankTokenCompleteMonobankCommand?: BankTokenCompleteMonobankCommand, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<BankTokenResponseDto>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.apiBankTokenMonobankCompletePost(bankTokenCompleteMonobankCommand, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['BankTokenApi.apiBankTokenMonobankCompletePost']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @param {object} [body] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async apiBankTokenMonobankInitPost(body?: object, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<BankTokenAddMonobankResponseDto>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.apiBankTokenMonobankInitPost(body, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['BankTokenApi.apiBankTokenMonobankInitPost']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @param {string} bankTokenUid 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async apiBankTokenMonobankStatusBankTokenUidGet(bankTokenUid: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<MonobankCheckRequestStatusDto>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.apiBankTokenMonobankStatusBankTokenUidGet(bankTokenUid, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['BankTokenApi.apiBankTokenMonobankStatusBankTokenUidGet']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @param {BankTokenAddPrivatBankCommand} [bankTokenAddPrivatBankCommand] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async apiBankTokenPrivatbankPost(bankTokenAddPrivatBankCommand?: BankTokenAddPrivatBankCommand, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<BankTokenResponseDto>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.apiBankTokenPrivatbankPost(bankTokenAddPrivatBankCommand, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['BankTokenApi.apiBankTokenPrivatbankPost']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
    }
};

/**
 * BankTokenApi - factory interface
 * @export
 */
export const BankTokenApiFactory = function (configuration?: Configuration, basePath?: string, axios?: AxiosInstance) {
    const localVarFp = BankTokenApiFp(configuration)
    return {
        /**
         * 
         * @param {string} bankTokenUid 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiBankTokenBankTokenUidDelete(bankTokenUid: string, options?: RawAxiosRequestConfig): AxiosPromise<void> {
            return localVarFp.apiBankTokenBankTokenUidDelete(bankTokenUid, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {string} bankTokenUid 
         * @param {BankTokenUpdateCommand} [bankTokenUpdateCommand] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiBankTokenBankTokenUidPut(bankTokenUid: string, bankTokenUpdateCommand?: BankTokenUpdateCommand, options?: RawAxiosRequestConfig): AxiosPromise<void> {
            return localVarFp.apiBankTokenBankTokenUidPut(bankTokenUid, bankTokenUpdateCommand, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiBankTokenGet(options?: RawAxiosRequestConfig): AxiosPromise<Array<BankTokenResponseDto>> {
            return localVarFp.apiBankTokenGet(options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {BankTokenCompleteMonobankCommand} [bankTokenCompleteMonobankCommand] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiBankTokenMonobankCompletePost(bankTokenCompleteMonobankCommand?: BankTokenCompleteMonobankCommand, options?: RawAxiosRequestConfig): AxiosPromise<BankTokenResponseDto> {
            return localVarFp.apiBankTokenMonobankCompletePost(bankTokenCompleteMonobankCommand, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {object} [body] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiBankTokenMonobankInitPost(body?: object, options?: RawAxiosRequestConfig): AxiosPromise<BankTokenAddMonobankResponseDto> {
            return localVarFp.apiBankTokenMonobankInitPost(body, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {string} bankTokenUid 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiBankTokenMonobankStatusBankTokenUidGet(bankTokenUid: string, options?: RawAxiosRequestConfig): AxiosPromise<MonobankCheckRequestStatusDto> {
            return localVarFp.apiBankTokenMonobankStatusBankTokenUidGet(bankTokenUid, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {BankTokenAddPrivatBankCommand} [bankTokenAddPrivatBankCommand] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiBankTokenPrivatbankPost(bankTokenAddPrivatBankCommand?: BankTokenAddPrivatBankCommand, options?: RawAxiosRequestConfig): AxiosPromise<BankTokenResponseDto> {
            return localVarFp.apiBankTokenPrivatbankPost(bankTokenAddPrivatBankCommand, options).then((request) => request(axios, basePath));
        },
    };
};

/**
 * BankTokenApi - object-oriented interface
 * @export
 * @class BankTokenApi
 * @extends {BaseAPI}
 */
export class BankTokenApi extends BaseAPI {
    /**
     * 
     * @param {string} bankTokenUid 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof BankTokenApi
     */
    public apiBankTokenBankTokenUidDelete(bankTokenUid: string, options?: RawAxiosRequestConfig) {
        return BankTokenApiFp(this.configuration).apiBankTokenBankTokenUidDelete(bankTokenUid, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {string} bankTokenUid 
     * @param {BankTokenUpdateCommand} [bankTokenUpdateCommand] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof BankTokenApi
     */
    public apiBankTokenBankTokenUidPut(bankTokenUid: string, bankTokenUpdateCommand?: BankTokenUpdateCommand, options?: RawAxiosRequestConfig) {
        return BankTokenApiFp(this.configuration).apiBankTokenBankTokenUidPut(bankTokenUid, bankTokenUpdateCommand, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof BankTokenApi
     */
    public apiBankTokenGet(options?: RawAxiosRequestConfig) {
        return BankTokenApiFp(this.configuration).apiBankTokenGet(options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {BankTokenCompleteMonobankCommand} [bankTokenCompleteMonobankCommand] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof BankTokenApi
     */
    public apiBankTokenMonobankCompletePost(bankTokenCompleteMonobankCommand?: BankTokenCompleteMonobankCommand, options?: RawAxiosRequestConfig) {
        return BankTokenApiFp(this.configuration).apiBankTokenMonobankCompletePost(bankTokenCompleteMonobankCommand, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {object} [body] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof BankTokenApi
     */
    public apiBankTokenMonobankInitPost(body?: object, options?: RawAxiosRequestConfig) {
        return BankTokenApiFp(this.configuration).apiBankTokenMonobankInitPost(body, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {string} bankTokenUid 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof BankTokenApi
     */
    public apiBankTokenMonobankStatusBankTokenUidGet(bankTokenUid: string, options?: RawAxiosRequestConfig) {
        return BankTokenApiFp(this.configuration).apiBankTokenMonobankStatusBankTokenUidGet(bankTokenUid, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {BankTokenAddPrivatBankCommand} [bankTokenAddPrivatBankCommand] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof BankTokenApi
     */
    public apiBankTokenPrivatbankPost(bankTokenAddPrivatBankCommand?: BankTokenAddPrivatBankCommand, options?: RawAxiosRequestConfig) {
        return BankTokenApiFp(this.configuration).apiBankTokenPrivatbankPost(bankTokenAddPrivatBankCommand, options).then((request) => request(this.axios, this.basePath));
    }
}

